import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import { notificationApi } from '@/services/notifications/notifications'
import type { IPagination } from '@/types'
import type { INotification, INotificationEvent } from '@/types/notifications'

interface NotificationState {
    notifications: INotification[]
    notificationsList: INotification[]
    notificationEvents: INotificationEvent[]
    loading: boolean
    error: string | null
    updateNotification: Partial<INotification>
    pagination: IPagination | null
    notificationsListPagination: IPagination | null
}

const initialState: NotificationState = {
    notifications: [],
    notificationEvents: [],
    loading: false,
    error: null,
    updateNotification: {},
    pagination: null,
    notificationsListPagination: null,
    notificationsList: [],
}

const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        clearNotifications(state) {
            state.notifications = []
        },
        setUpdateNotification: (
            state,
            action: PayloadAction<Record<string, any>>,
        ) => {
            state.updateNotification = {
                ...state.updateNotification,
                ...action.payload,
            }
        },
        setNotification(state, action) {
            state.notificationsList = [
                ...state.notificationsList,
                action.payload,
            ]
        },
        setNotifications(state, action) {
            state.notifications = action.payload
        },
    },
    extraReducers: builder => {
        builder.addMatcher(
            notificationApi.endpoints.getAllNotificationEvents.matchFulfilled,
            (state, { payload }) => {
                state.notificationEvents = payload.data || []
            },
        )

        builder.addMatcher(
            notificationApi.endpoints.getAllNotification.matchFulfilled,
            (state, { payload }) => {
                state.notifications = payload.data || []
                // @ts-expect-error бекенд шле "pagonation", а не "pagination"
                state.pagination = payload.pagonation || null
            },
        )

        builder.addMatcher(
            notificationApi.endpoints.getNotificationById.matchFulfilled,
            (state, { payload }) => {
                state.updateNotification = payload.data || null
            },
        )

        builder.addMatcher(
            notificationApi.endpoints.getAllNotification.matchRejected,
            (state, { error }) => {
                state.error = error.message || 'Failed to fetch notifications'
            },
        )

        builder.addMatcher(
            notificationApi.endpoints.createNotificationEvent.matchFulfilled,
            (state, { payload }) => {
                state.notificationEvents = [
                    ...state.notificationEvents,
                    payload.data,
                ]
            },
        )
        builder.addMatcher(
            notificationApi.endpoints.deleteNotification.matchFulfilled,
            (state, { payload }: any) => {
                state.notifications = state.notifications.filter(
                    notification => notification.id !== payload.id,
                )
            },
        )
        builder.addMatcher(
            notificationApi.endpoints.getMyNotification.matchFulfilled,
            (state, { payload }: any) => {
                state.notificationsList = [
                    ...state.notificationsList,
                    ...payload.data,
                ]
                state.notificationsListPagination = payload?.pagination
            },
        )
        builder.addMatcher(
            notificationApi.endpoints.markAllMyNotification.matchFulfilled,
            state => {
                state.notificationsList = []
                state.notificationsListPagination = null
            },
        )
    },
})

export const {
    clearNotifications,
    setUpdateNotification,
    setNotification,
    setNotifications,
} = notificationSlice.actions

export const selectNotifications = (state: any) =>
    state.notifications.notifications
export const selectNotificationEvents = (state: any) =>
    state.notifications.notificationEvents
export const selectUpdateNotification = (state: any) =>
    state.notifications.updateNotification
export const selectPagination = (state: any) => state.notifications.pagination
export const selectListPagination = (state: any) =>
    state.notifications.notificationsListPagination
export const selectNotificationList = (state: any) =>
    state.notifications.notificationsList

export default notificationSlice.reducer
